import React from "react";
import Grid from "@mui/material/Grid";
import styles from "./AboutProject.module.css";
import parse from "html-react-parser";
import { getValidUrl, isVideo } from "src/utils/commonCheck";
import Image from "next/image";

const AboutProject = ({ projectDetails, cfsItem }: any) => {
  let projDetail =
    cfsItem &&
    cfsItem?.items &&
    cfsItem?.items[0] &&
    cfsItem?.items[0]?.fields?.projectList?.filter(
      (item: any) => item?.fields?.mojitoCollectionId === projectDetails
    );
  return (
    <>
      {projDetail && projDetail[0] && (
        <Grid
          container
          spacing={2}
          className={`${"container"}  padding-section ${styles.abt_prj_wrp}`}
        >
          {(projDetail?.[0]?.fields?.aboutImage?.fields?.file?.url || projDetail[0]?.fields?.projectImage?.fields?.file?.url) && (
            <Grid item xs={12} md={6} sm={6}>
              <div className={styles.imgwrp}>
                {isVideo(
                  getValidUrl(
                    projDetail[0]?.fields?.aboutImage?.fields?.file?.url ?? projDetail[0]?.fields?.projectImage?.fields?.file?.url
                  )
                ) ? (
                  <video
                    controls
                    className="img-responsive"
                    loop
                    muted
                    playsInline
                    autoPlay={true}
                  >
                    <source
                      src={getValidUrl(
                        projDetail[0]?.fields?.aboutImage?.fields?.file?.url ?? projDetail[0]?.fields?.projectImage?.fields?.file?.url
                      )}
                    />{" "}
                  </video>
                ) : (
                  <Image
                    src={getValidUrl(
                      projDetail[0]?.fields?.aboutImage?.fields?.file?.url ?? projDetail[0]?.fields?.projectImage?.fields?.file?.url
                    )}
                    alt="project"
                    layout="responsive"
                    width={100}
                    height={100}
                    objectFit={"contain"}
                    unoptimized
                  />
                )}
              </div>
            </Grid>
          )}

          <Grid item xs={12} md={6} sm={6}>
            <div>
              {/* <span>About the project</span> */}
              <h1>{projDetail[0]?.fields?.artistName}</h1>

              <p>
                {
                  <>
                    {parse(
                      projDetail[0]?.fields?.aboutTheProject?.replaceAll(
                        "\n",
                        "<br/>"
                      ) ?? ""
                    )}
                  </>
                }
              </p>
            </div>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default AboutProject;
